export const validPhoneNumber = new RegExp(/^\+?[0-9]{9,12}$/i);

export const validEmail = new RegExp(
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
);

export const transformTurkish = (text) => {
  if (text) {
    return text.replace(/[CcÇçGgĞğIıİiOoÖöSsŞşUuÜü]/g, "_")
  }
  else { return "" }
};
